export default "__VITE_ASSET__780d9cd9__"